import Login from "@/components/public/Login.vue";
import PasswordReset from "@/components/public/PasswordReset.vue";
import PasswordForgot from "@/components/public/PasswordForgot.vue";
import InviteValidate from "@/components/public/InviteValidate.vue";
import Error from "@/components/public/Error.vue";
import { theme } from "@/services/config";

const publicRoutes = [
  {
    path: "/login",
    name: "login",
    meta: { isPublic: true },
    component: Login,
  },
  {
    // UC-REG-077: ruta white-label por org. /login/cnc carga el branding de
    // CNC (logo, colores, nombre) antes de mostrar el form. Si el slug no
    // existe, el componente cae silenciosamente al branding del tenant — no
    // redirige para no exponer la URL alt. Mismo componente que /login.
    path: "/login/:orgSlug",
    name: "login-org",
    meta: { isPublic: true },
    component: Login,
  },
  {
    path: "/password-forgot",
    name: "password-forgot",
    meta: { isPublic: true },
    component: PasswordForgot,
  },
  {
    path: "/password-reset/:token",
    name: "password-reset",
    meta: { isPublic: true },
    component: PasswordReset,
  },
  {
    path: "/invite/:code",
    name: "invite-validate",
    meta: { isPublic: true },
    component: InviteValidate,
  },
  {
    // Autoregistro de socios — gateado por SELF_SIGNUP_ENABLED
    // (services/constants.js, hoy solo Corporación Médica). El componente
    // mismo redirige a /login si el tenant no está habilitado (distinto
    // de /login/:orgSlug, que ante un slug inválido NO redirige, cae
    // silencioso al branding default). Lazy-loaded (como /portal y
    // /booking/:doctorSlug abajo): a diferencia de quantux-landing (Vite,
    // DCE estático via import.meta.env), acá webpack no puede tree-shakear
    // un v-if en runtime — sin el chunk separado, el form completo queda
    // embebido en TODOS los bundles de tenant, no solo el habilitado.
    // UC-REG-254: Campana tiene su PROPIA instancia del form
    // (`SelfSignUpCampana.vue`), aislada del de Corporación Médica por
    // decisión de producto. La elección es por THEME del build, así cada
    // bundle de tenant solo embebe su chunk.
    path: "/signup",
    name: "self-signup",
    meta: { isPublic: true },
    component: () =>
      theme === "campana"
        ? import("@/components/public/SelfSignUpCampana.vue")
        : import("@/components/public/SelfSignUp.vue"),
  },
  {
    path: "/portal",
    name: "portal",
    meta: { isPublic: true },
    component: () => import("@/components/public/DoctorPortal.vue"),
  },
  {
    path: "/booking/:doctorSlug",
    name: "doctor-booking",
    meta: { isPublic: true },
    component: () => import("@/views/patient/DoctorBooking.vue"),
  },
  {
    path: "/appointment/:appointmentId/:patientId",
    name: "patient-video-room",
    meta: { isPublic: true },
    component: () => import("@/views/PatientVideoRoom.vue"),
  },
  {
    // UC-REG-282: sala de espera de urgencias del paciente. Link enviado por
    // WhatsApp/mail al entrar a la cola; identidad por URL como la
    // videoconsulta.
    path: "/urgencia/:queueId/:patientId",
    name: "urgency-waiting-room",
    meta: { isPublic: true },
    component: () => import("@/views/UrgencyWaitingRoom.vue"),
  },
  {
    path: "*",
    name: "error",
    meta: { isPublic: true },
    component: Error,
  },
];

export default publicRoutes;
